import { useCallbackRef, useSafeLayoutEffect } from '@chakra-ui/react';

export const useBeforeUnload = (callback: (e?: Event) => void) => {
  const cb = useCallbackRef((event) => {
    event.preventDefault();
    callback?.(event);
  });

  useSafeLayoutEffect(() => {
    window.addEventListener('beforeunload', cb, { capture: true });

    return () => {
      window.removeEventListener('beforeunload', cb, { capture: true });
    };
  }, [cb]);
};
